<script lang="ts">
	import { onMount, tick } from 'svelte';
	import { Carousel } from './ts/Carousel';
      import { renderTick } from '$lib/utils/flip'
      import { Result } from '$lib/utils/result'

	let {
		selected = $bindable(),
		children = undefined,
		onmove = undefined,
		onend = undefined,
		before = undefined,
		after = undefined,
		slide = true,
		allowPropagation = false,
		class: className = '',
    carouselMin = undefined,
    carouselMax = undefined,
	} = $props();

	async function flip({ flipFn, element }: { flipFn: (...args: any) => any; element: HTMLElement }) {
    if(! element ) return
		element.getAnimations().forEach((a) => {
			a.pause();
		});

		const rect_start = element.getBoundingClientRect();

		flipFn();
		await tick();
		const rect_end = element.getBoundingClientRect();

		let duration = 0;
		if (slide) duration = (300 / 100 ) * Math.abs( (rect_start.x - rect_end.x)) / rect_start.width * 100;

		if (!Number.isFinite(duration)) duration = 100;
    if( duration > 1000 ) duration = 300

    //element.classList.add("carousel-move-motion")
    await Result( () => element.classList.add("carousel-move-motion"))
    
		const animation = element.animate(
      [
        {
          transform: `translateX(${rect_start.x - rect_end.x}px)`
				},
				{
          transform: `translateX(0px)`
				}
			],
			{ duration: duration < 0 ? 300 : duration, fill: 'none' }
		);
    
    await Result( async() => await animation.finished)

    await renderTick()
    await Result( () => element.classList.remove("carousel-move-motion"))

    return
	}

	function carouselOffset() {
		carouselMove.getAnimations().forEach((a) => {
			a.pause();
		});

		const item = controller.getElementByIndex(selected);
		left = controller.left;

		if (!item) return;

		item.getAnimations().forEach((a) => a.cancel());

		const offset = controller.getElementOffset(item);

		carouselMove.getAnimations().forEach((a) => {
			a.cancel();
		});

		const offset_delta = controller.getElementOffset(item);

		left = offset - (offset - offset_delta);

		controller.left = left;
		carouselMove.style.left = left + '%';
	}

	function setClasses() {
    if(!carousel) return
		const items = [...carousel.querySelectorAll('.' + id + ' \> .carousel-item')];
		items.forEach((item, i) => {
			item.classList.remove('selected', 'focusoff');
			if (i == focusoff) item.classList.add('focusoff');
			if (i == selected) item.classList.add('selected');
		});
	}

	function switchItems() {
		flip({
			flipFn: () => {
				carouselOffset();
			},
			element: carouselMove
		});

		focusoff = _selected;
		_selected = selected;
		setClasses();
	}

	$effect(() => {
		selected;
    if (!controller) {
      return;
    }
		//switchItems();
    render()
	});

  async function render() {
    await renderTick()
    switchItems()
  } 

	let controller: Carousel;
	let carousel: HTMLElement;
	let carouselMove: HTMLElement;

	let focusoff: number = -1;
	let _selected: number = 0;

	let left = 0;
	let id = $state('');

	onMount(() => {
		controller = new Carousel(carousel, onmove, onend, render);
		controller.setPropagation(allowPropagation);
		id = controller.getID();
    if( carouselMax ) controller.setMax( carouselMax )
    if( carouselMin ) controller.setMin( carouselMin )
		carouselMove.classList.add(id);
    
    render()
    //setTimeout( render, 200)
		//switchItems();
	});

  onMount(() => {
    window.addEventListener("resize", switchItems)

    return () => {
      window.removeEventListener("resize", switchItems)
    }

  })
</script>

{@render before?.()}

<div bind:this={carousel} class="carousel relative mx-auto h-full w-full ">
	<div bind:this={carouselMove} class="carousel-move relative h-full {className == '' ? 'grid' : className} translate-x-0 items-center justify-center">
		{@render children?.()}
	</div>
</div>

{@render after?.()}

<style lang="postcss">
	@reference "tailwindcss/theme";

	.grid.carousel-move {
		isolation: isolate;
		grid-template-columns: 100%;
		grid-auto-rows: 100%;
	}

	.grid.carousel-move > :global(*) {
		grid-area: 1/1;
	}
</style>
